"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getEnvURL = function getEnvURL() {
  var hostname = window.location.hostname; //for IE 11 Support

  var includes = function includes(container, value) {
    var returnValue = false;
    var pos = container.indexOf(value);

    if (pos >= 0) {
      returnValue = true;
    }

    return returnValue;
  };

  var url = "";

  switch (true) {
    case includes(hostname, "dev"):
      url = "fff-dev.com";
      break;

    case includes(hostname, "qa"):
      url = "fff-qa.com";
      break;

    case includes(hostname, "staging"):
      url = "fff-staging.com";
      break;

    case includes(hostname, "load"):
      url = "fff-load.com";
      break;

    default:
      url = "fabfitfun.com";
  }

  return url;
};

var staticURL = function staticURL() {
  return "https://static." + getEnvURL();
};

var getHomeUrl = function getHomeUrl() {
  return "https://" + getEnvURL();
};

exports.default = {
  staticURL: staticURL,
  getHomeUrl: getHomeUrl
};